<template>
    <div>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <v-img src="@/assets/user.png"></v-img>
              </v-list-item-avatar>
              {{usu.toUpperCase()}}
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-list nav dense shaped>
            <v-list-item-group color="success" v-model="selectedItem">
              <v-list-item v-for="(item, i) in items" :key="i" @click="OpcMenu(item)">
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>                  
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
    </div>
</template>
<script>
import EventBus from '../bus'
export default {
    name: 'Menu',
    props: ['usu'],
 data(){
    return {
     selectedItem: null,
      items: [
        { componente: 'DashBoard' , text: 'DashBoard', icon: 'dashboard' },
        { componente: 'Productos' , text: 'Productos', icon: 'unarchive' },
        { componente: 'Pedidos' , text: 'Compras / NC Proveedores', icon: 'archive' },
        { componente: 'Importaciones' , text: 'Importaciones', icon: 'flight_land' },
        { componente: 'Dte' , text: 'Cotización / Venta / Devolución', icon: 'assignment' },
        { componente: 'Caja' , text: 'Flujo Caja', icon: 'credit_card' },
        { componente: 'Inventario' , text: 'Inventario / Ingreso / Egreso', icon: 'iso' },
        { componente: 'Credito' , text: 'Credito Cobranza', icon: 'equalizer' },
        { componente: 'Gerencia' , text: 'Estadistica Gerencia', icon: 'insert_chart' },
        //{ componente: 'Cartera' , text: 'Balance Cartera', icon: 'account_balance_wallet' },
        { componente: 'Setup' , text: 'Configuración', icon: 'settings' },
        { componente: 'Reportes' , text: 'Reportes', icon: 'report' }
        //{ componente: 'Ecomerce' , text: 'Ecomerce', icon: 'shopping_basket' },
      ],
    }
  },
  methods:{
      OpcMenu(Opc){
        EventBus.$emit('Opcion-Menu', Opc)
      }
  }
}
</script>